import React from "react";
import { Auth0Provider } from "@auth0/auth0-react";

const Auth0ProviderWithHistory = ({ children }) => {
  const domain = 'dev-9cl726jg.us.auth0.com';
  const clientId = 'U6EZDpQ7HGxc5G5r2gVki6ncvxcvy58c';

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={`${window.location.origin}/home`}
      audience={"https://dev-9cl726jg.us.auth0.com/api/v2/"}
      scope={'read:users read:user_idp_tokens'}
    >
      {children}
    </Auth0Provider>
  );
};

export default Auth0ProviderWithHistory;